import { Skeleton, Stack } from '@mantine/core';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  height?: number;
}

/**
 * Skeleton for table components during loading/streaming states.
 * Renders a header row followed by data rows with varying widths.
 */
export function TableSkeleton({ rows = 5, columns: _columns = 4, height: _height }: TableSkeletonProps) {
  // Generate slightly varying widths for visual interest
  const rowWidths = Array.from({ length: rows }, (_, i) => 85 + ((i * 7) % 15));

  return (
    <Stack gap="xs">
      <Skeleton animate height={36} radius="sm" />
      {rowWidths.map((width, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list that never reorders
        <Skeleton animate height={32} key={i} radius="sm" width={`${width}%`} />
      ))}
    </Stack>
  );
}
